module.exports = __webpack_public_path__ + "static/media/window.0b1e3c36.svg";